import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AddressSearchItem from './AddressSearchItem';
const AddressSearchWidget = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React.createElement("div", { className: classNames('autocomplete', { hidden: ((_a = props.items) === null || _a === void 0 ? void 0 : _a.length) === 0 }) },
        React.createElement("ul", { id: props.id, role: "listbox", "aria-label": t('label.a11y.suggestedaddresses') }, (_b = props.items) === null || _b === void 0 ? void 0 : _b.map((sug, i) => (React.createElement(AddressSearchItem, { key: i, index: i, onMouseEnter: () => {
                props.setItemFocused(null);
            }, item: sug, selectSuggestion: props.selectSuggestion, suggestionText: props.suggestionText, focused: (props === null || props === void 0 ? void 0 : props.itemFocused) === i })))),
        props.attribution && React.createElement("div", { className: "attribution" }, props.attribution)));
};
export default AddressSearchWidget;
